'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import { usePlayer } from 'contexts/PlayerContext';
import PlayIcon from 'components/icons/PlayIcon';

// VideoPlayer pulls in the Vidstack player library, which isn't needed
// until the viewer actually interacts with the video. Loading it as a
// separate chunk keeps it out of the landing page's initial JS bundle.
const VideoPlayer = dynamic(() => import('components/media/VideoPlayer'), {
  ssr: false,
});

interface HumanaVideoSectionProps {
  source: string;
}

const HumanaVideoSection: React.FC<HumanaVideoSectionProps> = ({ source }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { player } = usePlayer();
  const playerReady = Boolean(player?.current);

  // play() has to run in the click gesture. The Vidstack chunk mounts after
  // first paint, so the control stays inactive until that instance exists.
  const handlePlayClick = () => {
    if (!player?.current) return;
    player.current.play();
    setIsPlaying(true);
  };

  return (
    <section className="video-section blue-gradient">
      <div className="video-frame">
        <h2>Find Medicare coverage that fits you in about 25 minutes.</h2>
        <div className="video-player-wrapper">
          {!isPlaying && (
            <div className="video-overlay video-overlay--humana">
              <button
                className="play-btn-desktop"
                onClick={handlePlayClick}
                disabled={!playerReady}
              >
                <PlayIcon size="small" />
                <span>See how ALEX can help you</span>
              </button>
              <button
                className="play-btn-mobile"
                onClick={handlePlayClick}
                disabled={!playerReady}
                aria-label="See how ALEX can help you"
              >
                <PlayIcon size="large" />
              </button>
            </div>
          )}
          <VideoPlayer source={source} autoPlay={false} />
        </div>
      </div>
    </section>
  );
};

export default HumanaVideoSection;
